import React from "react";

import { Code, WorkerIcon } from "@packages/ds";
import { Link } from "react-router-dom";

import useDecodedParams from "Hooks/useDecodedParams";
import useSelectorWithUrlParams from "Hooks/useSelectorWithUrlParams";
import { environmentSelector } from "Reducers/environment";
import { gitProjectSelector } from "Reducers/project/project";

import * as S from "./Workers.styles";

import type { ReturnAddClass } from "Reducers/environment/deployment";

export interface WorkerProps {
  worker: ReturnAddClass[string];
}

const Worker = ({ worker }: WorkerProps) => {
  const { projectId, organizationId, environmentId } = useDecodedParams<{
    projectId: string;
    organizationId: string;
    environmentId: string;
  }>();

  const project = useSelectorWithUrlParams(gitProjectSelector);
  const environment = useSelectorWithUrlParams(environmentSelector);

  const cmd = `ssh://${projectId}-${environment?.machine_name}--${worker?.name}@ssh.${project?.region}`;
  const workerUrl = `/${organizationId}/${projectId}/${encodeURIComponent(environmentId)}/services/${worker.name}`;

  const onClickWorker = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <>
      <S.Cell>
        <Link to={workerUrl} onClick={onClickWorker}>
          <S.Title>
            <S.RowLeftLayout>
              <WorkerIcon />

              {worker.displayName}
            </S.RowLeftLayout>
          </S.Title>
        </Link>
      </S.Cell>
      <S.Cell>{worker.type?.split(":")?.[1]}</S.Cell>
      <S.Cell>{worker.size}</S.Cell>
      <S.Cell>{worker.disk}</S.Cell>
      {project?.region && environment?.machine_name && worker?.name && (
        <Code.Block isCopyable singleLine id={cmd}>
          {cmd}
        </Code.Block>
      )}
    </>
  );
};

export default Worker;
